var map = {
	"./en/analyze.json": [
		98013,
		13
	],
	"./en/article.json": [
		92615,
		615
	],
	"./en/asset-overview.json": [
		92991,
		991
	],
	"./en/auth.json": [
		47149,
		149
	],
	"./en/calendar.json": [
		93561,
		561
	],
	"./en/chart.json": [
		27117,
		117
	],
	"./en/chat.json": [
		21453,
		453
	],
	"./en/common.json": [
		43194,
		194
	],
	"./en/countries.json": [
		55279,
		279
	],
	"./en/earnings.json": [
		8772,
		772
	],
	"./en/error.json": [
		16463,
		463
	],
	"./en/header.json": [
		35933,
		314
	],
	"./en/indicator.json": [
		49484,
		484
	],
	"./en/indicators.json": [
		77609,
		609
	],
	"./en/insights.json": [
		73854,
		854
	],
	"./en/intel.json": [
		48133,
		133
	],
	"./en/news.json": [
		80980,
		980
	],
	"./en/scenario.json": [
		18657,
		657
	],
	"./en/scenarioCommander.json": [
		65753,
		753
	],
	"./en/screener.json": [
		52403,
		784
	],
	"./en/seo.json": [
		31703,
		84
	],
	"./en/settings.json": [
		55582,
		582
	],
	"./en/snakes.json": [
		54918,
		918
	],
	"./en/subscription.json": [
		73462,
		462
	],
	"./en/watchlistManager.json": [
		59005,
		5
	],
	"./en/widget.json": [
		27639,
		639
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 10955;
module.exports = webpackAsyncContext;